export const CANCEL_DEFERRED_TRANSACTION_REQUEST =
  'CANCEL_DEFERRED_TRANSACTION_REQUEST';
export const CANCEL_DEFERRED_TRANSACTION_SUCCESS =
  'CANCEL_DEFERRED_TRANSACTION_SUCCESS';
export const CANCEL_DEFERRED_TRANSACTION_FAIL =
  'CANCEL_DEFERRED_TRANSACTION_FAIL';

export const CHECK_IF_CANCELED_DEFERRED_TRANSACTION_REQUEST =
  'CHECK_IF_CANCELED_DEFERRED_TRANSACTION_REQUEST';
export const CHECK_IF_CANCELED_DEFERRED_TRANSACTION_SUCCESS =
  'CHECK_IF_CANCELED_DEFERRED_TRANSACTION_SUCCESS';
export const CHECK_IF_CANCELED_DEFERRED_TRANSACTION_FAIL =
  'CHECK_IF_CANCELED_DEFERRED_TRANSACTION_FAIL';

export const FETCH_DEFERRED_COMPANY_TRANSACTION_REQUEST =
  'FETCH_DEFERRED_COMPANY_TRANSACTION_REQUEST';
export const FETCH_DEFERRED_COMPANY_TRANSACTION_SUCCESS =
  'FETCH_DEFERRED_COMPANY_TRANSACTION_SUCCESS';
export const FETCH_DEFERRED_COMPANY_TRANSACTION_FAIL =
  'FETCH_DEFERRED_COMPANY_TRANSACTION_FAIL';

export const FETCH_DEFERRED_USER_TRANSACTION_REQUEST =
  'FETCH_DEFERRED_USER_TRANSACTION_REQUEST';
export const FETCH_DEFERRED_USER_TRANSACTION_SUCCESS =
  'FETCH_DEFERRED_USER_TRANSACTION_SUCCESS';
export const FETCH_DEFERRED_USER_TRANSACTION_FAIL =
  'FETCH_DEFERRED_USER_TRANSACTION_FAIL';
